import { render, staticRenderFns } from "./PortSelect.vue?vue&type=template&id=354bccd3"
import script from "./PortSelect.vue?vue&type=script&lang=js"
export * from "./PortSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports